(() => {
  const modal = document.querySelector('.switch-comparison-modal');
  if (!modal) return;

  const closeButton = modal.querySelector('.close-comparative-modal');
  let triggerButton;

  function closeModal() {
    if (!modal.classList.contains('in')) return;

    modal.classList.remove('in');
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('switch-comparison-open');
    triggerButton?.focus();
  }

  function openModal(trigger) {
    triggerButton = trigger;
    modal.classList.add('in');
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('switch-comparison-open');
    closeButton?.focus();
  }

  document.querySelectorAll('.open-modal-swtiches').forEach((trigger) => {
    trigger.addEventListener('click', (event) => {
      event.preventDefault();
      openModal(trigger);
    });
  });

  closeButton?.addEventListener('click', closeModal);
  modal.addEventListener('click', (event) => {
    if (event.target === modal) closeModal();
  });

  document.addEventListener('keydown', (event) => {
    if (!modal.classList.contains('in')) return;

    if (event.key === 'Escape') {
      closeModal();
      return;
    }

    if (event.key !== 'Tab') return;

    const focusableElements = Array.from(
      modal.querySelectorAll('button:not([disabled]), a[href], [tabindex]:not([tabindex="-1"])')
    );
    if (!focusableElements.length) return;

    const firstFocusable = focusableElements[0];
    const lastFocusable = focusableElements[focusableElements.length - 1];

    if (event.shiftKey && document.activeElement === firstFocusable) {
      event.preventDefault();
      lastFocusable.focus();
    } else if (!event.shiftKey && document.activeElement === lastFocusable) {
      event.preventDefault();
      firstFocusable.focus();
    }
  });
})();
